import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorTranslateService {

  constructor(
    private translate: TranslateService
  ) { }

  public splitErrorMessageKeys(errors: string): string[] {
    return errors.split("; ")
      .map(key => key.trim())
      .sort((a, b) => a.localeCompare(b));
  }

  public translateErrorMessageKeys(errors: string): string[] {
    const keys = this.splitErrorMessageKeys(errors);
    return keys.map(key => this.translate.instant(key));
  }
}
